import angular from 'angular';
import angularGettext from 'angular-gettext';
import baSidebarServiceDecorator from './baSidebarServiceDecorator';
import baSidebarDirectiveDecorator from './baSidebarDirectiveDecorator';

let baSidebarServiceConfig = function ($provide) {
    /** @ngInject */

    $provide.decorator('baSidebarService', baSidebarServiceDecorator);
    $provide.decorator('baSidebarDirective', baSidebarDirectiveDecorator);
};

export default angular.module('cms.blur-admin.baSidebarDecorator', [angular.module('BlurAdmin.theme').name, angularGettext])
    .config(baSidebarServiceConfig).name;


// WEBPACK FOOTER //
// ./src/cmsCore/BlurAdmin/baSidebarDecorator/baSidebarDecorator.js